import React from "react"
import { Button } from "./ui/button"

/** value: [{ id?, description, amount, hsn_sac?, gst_tax_rate_id? }] — amount is display string */
export function DocumentLineRows({ value, onChange, gstRateOptions = null }) {
  const emptyRow = gstRateOptions
    ? { description: "", amount: "", hsn_sac: "", gst_tax_rate_id: "" }
    : { description: "", amount: "" }

  const rows = value?.length ? value : [emptyRow]

  function patchRow(i, patch) {
    onChange(rows.map((r, j) => (j === i ? { ...r, ...patch } : r)))
  }

  function addRow() {
    onChange([...rows, { ...emptyRow }])
  }

  function removeRow(i) {
    if (rows.length <= 1) {
      onChange([{ ...emptyRow }])
      return
    }
    onChange(rows.filter((_, j) => j !== i))
  }

  return (
    <div className="md:col-span-2 grid gap-4 rounded-xl border border-border/90 bg-muted/30 p-4 shadow-sm">
      <div className="text-xs text-muted-foreground">
        Line items (optional — when present, total is the sum of lines). With GST, amount is tax-inclusive for the
        selected slab.
      </div>
      <div className="grid gap-1">
        {rows.map((row, i) => (
          <div key={row.id ?? `new-${i}`} className="flex flex-wrap items-end gap-1.5">
            <label className="min-w-[120px] flex-1 grid gap-0.5 text-xs">
              <span className="text-muted-foreground">Description</span>
              <input
                type="text"
                value={row.description ?? ""}
                onChange={(e) => patchRow(i, { description: e.target.value })}
                className="w-full rounded-lg border border-input bg-card px-2.5 py-1.5 text-sm text-foreground outline-none transition-shadow focus:border-primary focus:ring-2 focus:ring-ring/20"
              />
            </label>
            {gstRateOptions ? (
              <>
                <label className="w-20 grid gap-0.5 text-xs">
                  <span className="text-muted-foreground">HSN/SAC</span>
                  <input
                    type="text"
                    value={row.hsn_sac ?? ""}
                    onChange={(e) => patchRow(i, { hsn_sac: e.target.value })}
                    className="w-full rounded-lg border border-input bg-card px-2.5 py-1.5 text-sm text-foreground outline-none transition-shadow focus:border-primary focus:ring-2 focus:ring-ring/20"
                  />
                </label>
                <label className="min-w-[140px] w-40 grid gap-0.5 text-xs">
                  <span className="text-muted-foreground">GST slab</span>
                  <select
                    value={row.gst_tax_rate_id ?? ""}
                    onChange={(e) => patchRow(i, { gst_tax_rate_id: e.target.value })}
                    className="w-full rounded-lg border border-input bg-card px-2.5 py-1.5 text-sm text-foreground outline-none transition-shadow focus:border-primary focus:ring-2 focus:ring-ring/20"
                  >
                    <option value="">None</option>
                    {gstRateOptions.map((o) => (
                      <option key={o.value} value={o.value}>
                        {o.label}
                      </option>
                    ))}
                  </select>
                </label>
              </>
            ) : null}
            <label className="w-28 grid gap-0.5 text-xs">
              <span className="text-muted-foreground">Amount</span>
              <input
                type="text"
                inputMode="decimal"
                value={row.amount ?? ""}
                onChange={(e) => patchRow(i, { amount: e.target.value })}
                className="w-full rounded-lg border border-input bg-card px-2.5 py-1.5 text-sm text-foreground outline-none transition-shadow focus:border-primary focus:ring-2 focus:ring-ring/20"
              />
            </label>
            <Button type="button" variant="ghost" className="h-8 shrink-0 px-2 text-xs text-red-600" onClick={() => removeRow(i)}>
              Remove
            </Button>
          </div>
        ))}
      </div>
      <div>
        <Button type="button" variant="ghost" className="h-8 px-2 text-xs" onClick={addRow}>
          Add line
        </Button>
      </div>
    </div>
  )
}
